module.exports = __webpack_public_path__ + "static/img/17.6c9c852.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ITInfrastructure/17.png
// module id = 4euO
// module chunks = 1